import React from "react";
import MaterialReactTable, { MaterialReactTableProps } from "material-react-table";
import { Loading } from "components/loading";

type RequiredProps<T extends Record<string, any>> = {
    data: MaterialReactTableProps<T>["data"];
    columns: MaterialReactTableProps<T>["columns"];
    tableContainerSx?: any;
};

type DefaultTableProps<T extends Record<string, any>> = RequiredProps<T> &
    Omit<MaterialReactTableProps<T>, "data" | "columns">;

export const DefaultTable = <T extends Record<string, any>>({
    data,
    columns,
    tableContainerSx,
    ...rest
}: DefaultTableProps<T>) => !data
        ? <Loading />
        : (
            <MaterialReactTable
                columns={columns}
                data={data}
                enablePagination={false}
                enableTopToolbar
                enableRowVirtualization
                muiTableContainerProps={{
                    sx: {
                        "& thead tr:first-of-type th:first-of-type > div": {
                            justifyContent: "center",
                        },
                        "& tbody tr td:first-of-type > div": {
                            paddingLeft: 0,
                            paddingRight: 0,
                            justifyContent: "center",
                        },
                        "& tbody tr td:first-of-type": {
                            justifyContent: "center",
                            textAlign: "center",
                            px: 0,
                        },
                        "& tbody tr:first-of-type td > p": {
                            display: "flex",
                            minWidth: "100%",
                            justifyContent: "center",
                        },
                        "& thead tr th": {
                            textAlign: "center",
                            padding: "8px 8px",
                        },
                        "& tbody tr td": {
                            padding: "8px 8px",
                        },
                        border: "1px solid #D9D9D9",
                        borderRadius: "10px",
                        width: "100%",
                        height: "fit-content",
                        maxHeight: "calc(100vh - 410px)",
                        ...tableContainerSx,
                    },
                }}
                muiTablePaperProps={{
                    sx: {
                        borderRadius: "10px",
                        boxShadow: "none",
                    },
                }}
                muiTopToolbarProps={{
                    sx: {
                        height: '1px',
                        minHeight: '1px',
                        backgroundColor: 'transparent',
                        '& .MuiIconButton-root': {
                            display: 'none',
                        },
                    },
                }}
                muiBottomToolbarProps={{
                    sx: {
                        display: "none",
                    },
                }}
                muiTableHeadCellProps={{
                    sx: {
                        lineHeight: "30px",
                        textAlign: "center",
                        "& .MuiBadge-root": {
                            display: "none",
                        },
                        "&:first-of-type": {
                            textAlign: "center",
                            "& > div": {
                                justifyContent: "center",
                            },
                        },
                    },
                }}
                muiTableHeadRowProps={{
                    sx: {
                        height: "45px",
                        backgroundColor: "#F8FAFC",
                    },
                }}
                muiTableBodyRowProps={{
                    sx: {
                        minHeight: "45px",
                        height: "fit-content",
                        backgroundColor: "white",
                    },
                }}
                {...rest}
            />
        )